

import {defineComponent} from "vue";
import VueToggles, {VueTogglesProps} from "vue-toggles";




export default defineComponent({
  name: "ToggleInput.vue",
  components: {VueToggles},
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    label: String,
    checkedText: {
      type: String,
      default: ""
    },
    uncheckedText: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 75
    },
    height: {
      type: Number,
      default: 25
    }
  },

  emits: ["update:modelValue"],
  setup(props, context) {

    function onClick() {
      context.emit("update:modelValue", !props.modelValue);
    }

    return {
      onClick
    }
  }
})
